import { useRef, useState } from "react";
import { Col, Card, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import classes from "../createOrderDelivery.module.scss";

import { ReactComponent as AddIcon } from "@/assets/images/desktop/agregar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

import { formatMiles } from "@/services/Utils";
import Fetching from "@/components/Fetching/Fetching";
import { useDelDocument, useSaveDocument } from "@/hooks/purchases/purchases";

const CreateOrderDeliveryDocument = ({ data, setData }) => {
	const location = useLocation();
	const refFile = useRef(null);
	const { addToast } = useToasts();

	const [activeDocument, setActiveDocument] = useState(true);

	const { mutate: saveDocument, isLoading: loadDoc } = useSaveDocument();
	const { mutate: delDocument, isLoading: loadDelDoc } = useDelDocument();

	const handleSaveDocument = async (e) => {
		const files = e.target.files;

		if (files && files.length !== 0) {
			let newDocuments = [...data.documents];
			let validDocuments = true;

			for (var i = 0; i < files.length; i++) {
				const base64_file = await new Promise((resolve, reject) => {
					if (files[i]) {
						const reader = new FileReader();
						reader.readAsDataURL(files[i]);
						reader.onload = () => resolve(reader.result);
						reader.onerror = (error) => reject(error);
					}
				});

				if (files[i].size / 1024 / 1024 < 5) {
					newDocuments.push({
						id: "",
						name: files[i].name,
						url: base64_file,
						size: files[i].size,
						type: files[i].name.split(".").pop(),
						related_table: "orders_delivery",
					});
				} else {
					validDocuments = false;
				}
			}

			if (!validDocuments) {
				addToast("El documento supera el peso máximo permitido (5MB).", {
					appearance: "error",
				});
			}

			if (newDocuments.length !== data.documents.length) {
				saveDocument(
					{
						id: data.id,
						documents: newDocuments,
						pathname: location.pathname,
					},
					{
						onSuccess: (response) => {
							setData({ ...data, documents: response.files });
						},
					},
				);
			}
		}
	};

	const handleDeleteDocument = (document) => {
		delDocument(
			{ document },
			{
				onSuccess: (_response) => {},
			},
		);
	};

	const handleDeleteFile = (i) => {
		const newDocuments = [...data.documents];

		if (newDocuments[i] && newDocuments[i].id !== "") {
			handleDeleteDocument(newDocuments[i]);
		} else {
			newDocuments.splice(i, 1);
			setData({ ...data, documents: newDocuments });
		}
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={`${classes.files} ${activeDocument && "active"}`}>
				<Card.Header onClick={() => setActiveDocument(!activeDocument)} className={activeDocument && "active"}>
					Documentos
					<div>
						<span>
							<strong> Cant. Documentos:</strong> {formatMiles(data && data.documents ? data.documents.length : 0)}
						</span>
					</div>
				</Card.Header>

				{loadDoc || loadDelDoc ? (
					<Fetching topMargin={"1em"} bottomMargin={"1em"} />
				) : (
					activeDocument && (
						<>
							<Card.Body>
								{data &&
									data.documents &&
									data.documents.map((file, i) => {
										return (
											<Row className={classes.row_file} key={i}>
												<Col md={1} xs={1} className={classes.file_number}>
													{`${i + 1}.`}
												</Col>
												<Col
													md={9}
													xs={9}
													className={classes.file_name}
													onClick={() => {
														const link = document.createElement("a");
														link.href = file.url;
														link.download = file.name;
														if (["pdf", "png", "jpeg", "jpg"].includes(file.extension)) {
															link.target = "_blank";
														}
														link.click();
													}}
												>
													{file.name}
												</Col>
												<Col md={2} xs={2}>
													<RemoveSvg className={classes.delete_file} onClick={() => handleDeleteFile(i)} />
												</Col>
											</Row>
										);
									})}
							</Card.Body>
							<Card.Footer>
								<input style={{ display: "none" }} type="file" multiple ref={refFile} onChange={(e) => handleSaveDocument(e)} />

								<AddIcon className={classes.iconAdd} onClick={(_e) => refFile.current && refFile.current.click()} />
							</Card.Footer>
						</>
					)
				)}
			</Card>
		</Col>
	);
};

export default CreateOrderDeliveryDocument;
